<template>
  <component :is="embedded ? 'div' : 'section'" :class="rootClass">
    <div :class="embedded ? null : 'dept-modern'">
      <div class="dept-facts__panel" :class="{ 'dept-facts__panel--compact': compact }">
        <header class="dept-facts__header">
          <h2 v-if="heading" class="dept-facts__title">{{ heading }}</h2>
          <p v-if="updatedAt" class="dept-facts__updated">
            Информация обновлена: {{ updatedAt }}
          </p>
        </header>
        <div v-if="cards.length" class="dept-facts__grid" :class="{ 'dept-facts__grid--compact': compact }">
          <article
            v-for="(card, idx) in cards"
            :key="idx"
            class="dept-facts__card"
          >
            <h3 class="dept-facts__card-title">{{ card.title }}</h3>
            <ul v-if="card.items && card.items.length" class="dept-facts__card-list">
              <li v-for="(item, i) in card.items" :key="i">{{ item }}</li>
            </ul>
            <p v-else-if="card.content" class="dept-facts__card-content">{{ card.content }}</p>
          </article>
        </div>
        <p v-if="disclaimer" class="dept-facts__disclaimer">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
          </svg>
          {{ disclaimer }}
        </p>
      </div>
    </div>
  </component>
</template>

<script>
export default {
  name: 'DepartmentFacts',
  props: {
    heading: { type: String, default: '' },
    updatedAt: { type: String, default: '' },
    cards: { type: Array, default: () => [] },
    disclaimer: { type: String, default: '' },
    embedded: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
  },
  computed: {
    rootClass() {
      return this.embedded
        ? 'dept-facts dept-facts--embedded'
        : 'dept-facts dept-modern__section';
    },
  },
};
</script>

<style scoped lang="scss">
$green: #66cc66;
$green-text: #336633;

.dept-facts--embedded {
  height: 100%;
}

.dept-facts__panel {
  padding: 28px 32px;
  background: #eaf7ea;
  border-radius: 20px;
  border: 1px solid #c5dcc7;
  box-shadow: 0 2px 12px rgba(102, 204, 102, 0.05);
  box-sizing: border-box;

  &--compact {
    padding: 24px 26px;
  }

  @media (max-width: 767.98px) {
    padding: 22px 18px;
  }
}

.dept-facts__header {
  margin-bottom: 18px;
}

.dept-facts__title {
  margin: 0 0 6px;
  font-family: "TTDrugs", sans-serif;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  color: $green-text;

  @media (max-width: 767.98px) {
    font-size: 20px;
  }
}

.dept-facts__updated {
  margin: 0;
  font-family: "Circe", sans-serif;
  font-size: 14px;
  color: #5a6b5c;
}

.dept-facts__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;

  &--compact {
    gap: 10px;
  }

  @media (max-width: 1199.98px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 479.98px) {
    grid-template-columns: 1fr;
  }
}

.dept-facts__card {
  padding: 14px 14px 16px;
  background: #fff;
  border-radius: 14px;
  border: 1px solid #d4e5d6;
  min-width: 0;
}

.dept-facts__card-title {
  margin: 0 0 8px;
  font-family: "TTDrugs", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  color: $green-text;
}

.dept-facts__card-list {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    font-family: "Circe", sans-serif;
    font-size: 13px;
    line-height: 1.4;
    color: #4b5563;
    margin-bottom: 3px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.dept-facts__card-content {
  margin: 0;
  font-family: "Circe", sans-serif;
  font-size: 13px;
  line-height: 1.45;
  color: #4b5563;
}

.dept-facts__disclaimer {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  font-family: "Circe", sans-serif;
  font-size: 13px;
  line-height: 1.4;
  color: #5a6b5c;

  svg {
    flex-shrink: 0;
    margin-top: 1px;
    color: $green;
  }
}
</style>
